import { inject, Signal } from '@angular/core';
import { toSignal, ToSignalOptions } from '@angular/core/rxjs-interop';
import { Selector, Store } from '@ngrx/store';

export function injectFromStore<TState, TResult>(
    selector: Selector<TState, TResult>,
    options?: ToSignalOptions<TResult | undefined>,
): Signal<TResult | undefined> {
    const store = inject(Store<TState>);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return toSignal(store.select(selector), options as any);
}
